import { makeStyles } from '@material-ui/core';
import AngrySvg from 'assets/images/angry.svg';
import React, { ReactElement } from 'react';

const useStyles = makeStyles(() => ({
  logo: {
    width: '24px',
    height: '24px',
    objectFit: 'cover',
  },
}));

function Angry(): ReactElement {
  const classes: any = useStyles();
  return <img src={AngrySvg} alt="Angry icon" className={classes.logo} />;
}

export default Angry;
